

import { Vue, Component, Prop } from 'vue-property-decorator'
import { BlockProductColumnsItem } from '~/interfaces/components'
import BlockHeader from '~/components/shared/block-header.vue'
import ProductCard from '~/components/shared/product-card.vue'

@Component({
    components: { BlockHeader, ProductCard }
})
export default class BlockProductColumns extends Vue {
    @Prop({ type: Array, default: () => [] }) readonly columns!: BlockProductColumnsItem[]
}

